module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticePointingUp3.png
// module id = 2366
// module chunks = 2